module.exports = __webpack_public_path__ + "img/shhnw.7429adfc.png";